import React from "react";
import PercentageCard from "./PercentageCard";

const Percentage = () => {
  const stats = [
    { percent: 80, label: "Business Success" },
    { percent: 90, label: "Project Handover" },
    { percent: 80, label: "Business Success" },
    { percent: 90, label: "Project Handover" },
  ];

  return (
    <section className="w-full md:py-20 py-10 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-4 sm:grid-cols-2 gap-10 place-items-center">
        {stats.map((item, index) => (
          <PercentageCard index={index} key={index} {...item} />
        ))}
      </div>
    </section>
  );
};

export default Percentage;
